<template>
  <v-card :to="to" @click="handleClick" link flat>
    <v-card-title class="subtitle-2 mb-0 pb-0">
      <span v-html="title"></span>
      <v-spacer></v-spacer>
      <v-chip label x-small v-if="append" outlined>
        {{ append }}
      </v-chip>
    </v-card-title>
    <v-card-text class="mt-0 pt-1">
      <v-list-item-subtitle class="d-flex d-flex-row">
        <slot></slot>
      </v-list-item-subtitle>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  mixins: [],

  components: {},

  props: {
    title: String,
    append: String,
    to: [String, Object],
  },

  data() {
    return {};
  },

  methods: {
    handleClick() {
      this.$emit("click");
    },

  },

  computed: {},
};
</script>
